<template>
  <!--切换项目selector-->
  <a-space>
    <template v-if="tenantList.length > 1">
      <label style="color: white;">选择租户：</label>
      <a-select
        v-model:value="tenantId"
        placeholder="请选择账号所属租户"
        style="width: 300px;text-align: left;"
        :options="tenantList"
        :fieldNames="{ label: 'name', value: 'id' }"
        @change="changeTenant"
      ></a-select>
    </template>
    <label style="color: white;">选择项目：</label>
    <a-tree-select
      v-model:value="projectId"
      :tree-data="projectTreeList"
      :placeholder="'请选择项目'"
      :fieldNames="{ value: 'id', label: 'projectName', children: 'children' }"
      @change="handleProjectChange"
      style="width: 300px;text-align: left;"
      tree-default-expand-all
      allow-clear
      show-search
    />
<!--    <a-select v-model:value="projectId" :options="projectTreeList" :placeholder="'请选择项目'"-->
<!--      :fieldNames="{ value: 'id', label: 'projectName' }" @change="handleProjectChange" style="width: 300px;text-align: left;"></a-select>-->
  </a-space>
  <a-dropdown v-model:visible="mobileCodeVisible" placement="bottom">
    <a class="ant-dropdown-link" @click.prevent style="padding: 0 0 0 15px;">
      <img src="@/assets/mobile-code.png" alt="" style="vertical-align: text-top;">
    </a>
    <template #overlay>
      <img src="@/assets/mobile-qrcode.png" alt="" class="qrode-code">
    </template>
  </a-dropdown>
  <a-dropdown class="ant-pro-dropdown ant-pro-dropdown-action" placement="bottomRight" :trigger="['click']"
    v-model:visible="visible" overlayClassName="pro-components-header-notice-icon-index-container">

    <span :class="['noticeButton', { opened: visible }]">

      <a-badge :count="count" :style="{ boxShadow: 'none' }" class="badge">
        <slot name="bell">
          <bell-outlined class="icon" style="color: #ffffff;" />
        </slot>
      </a-badge>
    </span>
    <template #overlay>
      <div>
        <!-- <a-spin :spinning="loading" :delay="300"> -->
        <slot />
        <!-- </a-spin> -->
      </div>
    </template>
  </a-dropdown>
</template>
<script lang="ts">
import {ref, defineComponent, onMounted, onUnmounted} from 'vue';
import { BellOutlined } from '@ant-design/icons-vue';
import { getProjectListByPermission} from "@/api/project/project";
import {
  getCachedProjectIdWithoutCache,
  setCachedProjectId,
  setCachedTenantId,
} from "@/store/projectStore";
import {getTenantListByCurrentUser, updateLog} from "@/api/system/user";
import { message } from 'ant-design-vue';
import { eventBus } from '@/utils/eventBus';
export default defineComponent({
  name: 'NoticeDropdown',
  props: {
    count: Number,
    loading: Boolean,
  },
  slots: ['bell'],
  components: {
    BellOutlined,
  },
  setup() {

    const visible = ref(false);
    const mobileCodeVisible = ref(false);
    const projectTreeList = ref([]);
    const projectId = ref(null);
    const tenantList = ref([]);
    const tenantId = ref(null);
    const allData = ref([]);

    // 将扁平数据转换为树形结构的函数
    const convertToTree = (list) => {
      if (!list || list.length === 0) return [];

      const map = {};
      const roots = [];

      // 初始化所有节点
      list.forEach(item => {
        map[item.id] = { ...item, children: [] };

      });

      // 构建树形结构
      list.forEach(item => {
        const node = map[item.id];
        if (node.projectType !== '0') {
          node.disabled = true;
        }
        // 检查是否为根节点：parentId 不存在、为 null、为 undefined 或为空字符串
        if (!item.parentId || item.parentId === null || item.parentId === undefined || item.parentId === '') {
          roots.push(node);
        } else {
          // 有父节点的情况
          if (map[item.parentId]) {
            map[item.parentId].children.push(node);
          } else {
            // 如果找不到父节点，也将其作为根节点处理
            roots.push(node);
          }
        }
      });

      return roots;
    };

    const changeTenant = (_value) => {
      const filterData = allData.value.filter(item => item.tenantId === _value);
      projectTreeList.value = convertToTree(filterData);
      
      if (projectTreeList.value.length === 0) {
        projectId.value = null;
      } else {
        const firstNode = projectTreeList.value[0];

        // 如果首节点无子节点，直接使用其ID
        if (!firstNode.children || firstNode.children.length === 0) {
          projectId.value = firstNode.id;
        } else {
          // 递归查找最深层的叶子节点ID
          projectId.value = findDeepestLeafId(firstNode);
        }
      }
      setCachedProjectId(projectId.value);
      setCachedTenantId(_value);
    };

    // 递归查找最深层的叶子节点ID
    function findDeepestLeafId(node) {
      if (!node.children || node.children.length === 0) {
        return node.id;
      }

      // 始终选择第一个子节点向下递归
      return findDeepestLeafId(node.children[0]);
    }

    onMounted(async () => {
      await initProjectData();

      // 监听项目新增事件
      eventBus.on('projectAdded', initProjectData);
    });

    onUnmounted(() => {
      // 清理事件监听
      eventBus.off('projectAdded', initProjectData);
    });

    const initProjectData = async () => {
      sessionStorage.setItem('projectInitializing', 'true');
      await getTenantListByCurrentUser().then((res) => {
        if (res && res.data) {
          tenantList.value = res.data;
        }
      });
      await getProjectListByPermission().then( async (res) => {
        if (res) {
          if (!res.data || res.data.length === 0) {
            message.info('当前没有可以选择的项目');
            setCachedProjectId(null);
            return;
          }
          let cachedProjectId = await getCachedProjectIdWithoutCache();
          const allIds = res.data.map(item => item.id);
          if (!cachedProjectId || !allIds.includes(cachedProjectId)) {
            cachedProjectId = res.data.filter(item => item.projectType === '0')?.[0]?.id;
          }
          projectId.value = cachedProjectId;
          const selectedProject = res.data.find(item => item.id === cachedProjectId);
          if (selectedProject) {
            tenantId.value = selectedProject.tenantId;
            setCachedTenantId(tenantId.value);
          } else if (tenantList.value?.length) {
            tenantId.value = tenantList.value[0].id;
            setCachedTenantId(tenantId.value);
          }
          allData.value = res.data;
          const filterData = res.data.filter(item => item.tenantId === tenantId.value);
          projectTreeList.value = convertToTree(filterData);
          setCachedProjectId(cachedProjectId);
          updateLog(projectId.value);
        }
      });
      // 初始化完成，移除标志
      sessionStorage.removeItem('projectInitializing');
    };

    const handleProjectChange = (value) => {
      debugger
      setCachedProjectId(value);
      updateLog(value);
    };

    return {
      visible,
      projectTreeList,
      projectId,
      mobileCodeVisible,
      handleProjectChange,
      tenantList,
      tenantId,
      changeTenant,
    };
  },
});
</script>
<style lang="less" scoped>
.popover {
  position: relative;
  width: 336px;
}

.noticeButton {
  display: inline-block;
  cursor: pointer;
  transition: all 0.3s;
}

.icon {
  padding: 4px;
  vertical-align: middle;

}

.badge {
  font-size: 16px;
}

.qrode-code {
  width: 150px;
  height: 150px;
  background-color: white;
  border-radius: 4px;
  padding: 15px;
  margin-top: 15px;
  box-sizing: border-box;
}

.tabs {
  :deep(.ant-tabs-nav-list) {
    margin: auto;
  }

  :deep(.ant-tabs-nav-scroll) {
    text-align: center;
  }

  :deep(.ant-tabs-bar) {
    margin-bottom: 0;
  }
}
</style>
<style lang="less">
.pro-components-header-notice-icon-index-container>* {
  position: relative;
  width: 750px;
  background-color: @popover-bg;
  border-radius: 4px;
  box-shadow: @shadow-1-down;
}

@media screen and (max-width: @screen-xs) {
  .pro-components-header-notice-icon-index-container {
    width: 100% !important;
  }

  .pro-components-header-notice-icon-index-container>* {
    width: 100% !important;
    border-radius: 0 !important;
  }
}
</style>
